var _desc, _defs, _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBottomCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1131_134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame 116",
    width: 20,
    height: 20,
    transform: "translate(10.000000 10.000000)",
    fill: "white",
    fillOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#151319",
    strokeOpacity: 1,
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1131_134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.9399 14.1062L19.9399 25.7728M25.7732 19.9396L19.9399 25.7728L14.1064 19.9396",
    stroke: "#151319",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBottomCircle);
export default __webpack_public_path__ + "static/media/ic_bottom_circle.4c87fd7e18b21f98fe1e75613e40bf3d.svg";
export { ForwardRef as ReactComponent };